import { Text } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const OldBrowserWarning: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Text variant="body6" align="center">
        {
          t("10811") /* Para que tenha uma melhor experiência, recomendamos que
        use um browser mais recente. */
        }
      </Text>
    </Container>
  );
};

export default OldBrowserWarning;

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.light};
  padding: 10px;
`;
